export default __webpack_public_path__ + "6b3820b7e4ed47a744751e4f9ee4c2c5.png";